import { AnimatedCurrency, AnimatedNumber } from "@msuite/ui/animated";
import { Button } from "@msuite/ui/button";
import { ContentCard } from "@msuite/ui/content-card";
import { DataGrid } from "@msuite/ui/data-grid";
import { icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { calculateCalculation } from "@msuite/utils/calculations";
import { guardNumber } from "@msuite/utils/numbers";
import type { CalculationFormSchema } from "@msuite/utils/schemas";
import { useFormContext, useWatch } from "react-hook-form";
import { useCalculationEditorContext } from "@/sites/calculations/calculation-editor/context";

export function CalculationFormFooter() {
	/** Hooks */
	const { handleOnSubmit, isSubmitting } = useCalculationEditorContext();
	const { t } = useTranslation();
	const methods = useFormContext<CalculationFormSchema>();
	const services = useWatch({ control: methods.control, name: "services" });
	const total = calculateCalculation(services);

	/** Render */
	return (
		<ContentCard
			title={t("general.summary")}
			icon={icon("Calculator")}
			variant="plain"
		>
			<DataGrid
				align="left"
				variant="border"
				className="-mx-1.5"
			>
				<DataGrid.Row>
					<DataGrid.Label>{t("organization.data.services")}</DataGrid.Label>
					<DataGrid.Cell>
						<AnimatedNumber
							continuous={false}
							className="font-bold"
							value={guardNumber(services?.length)}
						/>
					</DataGrid.Cell>
				</DataGrid.Row>
				<DataGrid.Row>
					<DataGrid.Label>{t("invoices.sum_net")}</DataGrid.Label>
					<DataGrid.Cell>
						<AnimatedCurrency
							continuous={false}
							className="font-bold"
							value={total}
						/>
					</DataGrid.Cell>
				</DataGrid.Row>
			</DataGrid>
			<div className="h-stack justify-end">
				<Button
					variant="primary"
					isLoading={isSubmitting}
					onClick={() => {
						handleOnSubmit(true);
					}}
				>
					{t("general.done")}
				</Button>
			</div>
		</ContentCard>
	);
}
